import {Link, useNavigate} from 'react-router';

import {statsRowT} from '@/lib/types/stats.types';

import {useViewQuery} from '@/hooks';

import {StatsRowComponent} from '@/components';
import Page from '@/components/Page';
import {DataTableRpc} from '@/components/dataTableRpc';

function SpeculatorProducts() {
  const navigate = useNavigate();
  const {data: stats} = useViewQuery({
    view: 'product_stats',
  });

  // Stats
  const statsRow: statsRowT = [
    {
      title: 'Total Products',
      value: stats?.total,
      subtitle: 'This Month',
      icon: 'ri-stack-line',
      color: 'primary',
      change: 1.03,
      cardClass: 'Stats-main-card primary',
    },
    {
      title: 'Total Active Products',
      value: stats?.active,
      subtitle: 'This Month',
      icon: 'ri-money-dollar-circle-line',
      color: 'warning',
      change: -1.28,
      cardClass: 'Stats-main-card warning',
    },
    {
      title: 'Total Inactive Products',
      value: stats?.inactive,
      subtitle: 'This Month',
      icon: 'ri-money-dollar-box-line',
      color: 'secondary',
      change: -1.28,
      cardClass: 'Stats-main-card secondary',
    },
  ];

  return (
    <Page currentPage="Products">
      <StatsRowComponent stats={statsRow} />

      <DataTableRpc
        functionName="get_product_summary"
        columns={[
          {
            header: 'Logo',
            field: 'product_image_url',
            render: row => (
              <img src={row.product_image_url || '/images/logo/logo.png'} alt="Product Logo" className="h-10 w-10" />
            ),
          },
          {
            header: 'Name',
            field: 'product_name',
            render: row => (
              <Link className="text-primary hover:cursor-pointer hover:underline" to={`/products/${row.product_id}`}>
                {row.product_name}
              </Link>
            ),
          },
          {
            header: 'Category',
            field: 'product_category',
          },
          {
            header: 'Sub Category',
            field: 'product_subcategory',
          },
          {
            header: 'Ancestry',
            field: 'product_ancestor_category',
          },
          {
            header: 'Tags',
            field: 'product_tags',
          },
          {
            header: 'Brand Logo',
            field: 'brand_logo_url',
            render: row => (
              <img src={row.brand_logo_url || '/images/logo/logo.png'} alt="Brand Logo" className="h-10 w-10" />
            ),
          },
          {
            header: 'Distributor Inventory',
            field: 'distributor_count',
          },
          {
            header: 'Retailer Inventory',
            field: 'retailer_count',
          },
          {
            header: 'Positions',
            field: 'positions_count',
          },
        ]}
        actions={[
          {
            icon: 'ri-eye-line',
            color: 'primary',
            handler: row => {
              navigate(`/products/${row.product_id}`);
            },
            permission: () => true,
          },
        ]}
      />
    </Page>
  );
}

export default SpeculatorProducts;
